import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Typography, Radio } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { LoadingButton } from '@mui/lab';
import Header from '../../../../components/Header';
import CustomProgressBar from '../../../../components/CustomProgressBar';

const useStyle = makeStyles({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 30
  },
  alignEnd: {
    justifyContent: 'flex-end'
  },
  buttonStyle: {
    width: '15%',
    borderRadius: '20px'
  },
  questionsContainer: {
    marginTop: 25
  },
  answerContainer: {
    display: 'flex',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    borderRadius: 8,
    alignItems: 'center',
    margin: '10px 0'
  }
});

export default function InAppTest({
  title,
  onBack,
  testQuestion,
  updateQuestions,
  submitTest,
  testSubmitting
}) {
  const classes = useStyle();
  const [selectedQuestion, setSelQuestion] = useState(1);
  // const [selectedAnsIndexArray, setSelAnsIndexArray] = useState([]);
  // const [answeredArray, setAnsweredArray] = useState([]);

  // function insertAt(array, arrayName, index, value) {
  //   const newArray = [...array];
  //   if (newArray[index] !== undefined) {
  //     newArray[index] = value;
  //   } else {
  //     newArray.splice(index, 0, value);
  //   }
  //   if (arrayName === 'answered') {
  //     setAnsweredArray(newArray);
  //   } else if (arrayName === 'answeredIndex') {
  //     setSelAnsIndexArray(newArray);
  //   }
  // }

  const nextQuestion = () => {
    setSelQuestion(selectedQuestion + 1);
  };

  return (
    <div>
      {title && <Header title={title} onBack={onBack} />}
      <CustomProgressBar label="Question" from={selectedQuestion} to={testQuestion.length} />
      <div className={classes.questionsContainer}>
        <Typography variant="h5">
          {selectedQuestion}. {testQuestion[selectedQuestion - 1].name}
        </Typography>
        {testQuestion[selectedQuestion - 1].options.map((obj, i) => (
          <div className={classes.answerContainer} key={i}>
            <Radio
              checked={obj.isSelected}
              onChange={() => {
                // update options
                const newOptions = testQuestion[selectedQuestion - 1].options.map((op) => {
                  if (op._id === obj._id) {
                    op.isSelected = true;
                  } else {
                    op.isSelected = false;
                  }
                  return op;
                });
                testQuestion[selectedQuestion - 1].options = newOptions;
                updateQuestions([...testQuestion]);
              }}
            />
            <Typography>{obj.value}</Typography>
          </div>
        ))}
      </div>
      <div
        className={`${classes.buttonContainer} ${selectedQuestion === 1 ? classes.alignEnd : ''}`}
      >
        {selectedQuestion !== 1 && (
          <Button
            disabled={testSubmitting}
            variant="outlined"
            className={classes.buttonStyle}
            onClick={() => setSelQuestion(selectedQuestion - 1)}
          >
            Back
          </Button>
        )}
        <LoadingButton
          variant="contained"
          loading={testSubmitting}
          className={classes.buttonStyle}
          onClick={
            testQuestion.length === selectedQuestion ? () => submitTest() : () => nextQuestion()
          }
        >
          {testQuestion.length === selectedQuestion ? 'Submit' : 'Next'}
        </LoadingButton>
      </div>
    </div>
  );
}

InAppTest.propTypes = {
  title: PropTypes.string,
  onBack: PropTypes.func,
  testQuestion: PropTypes.array,
  updateQuestions: PropTypes.func,
  submitTest: PropTypes.func,
  testSubmitting: PropTypes.bool
};
